import { throttle } from 'lodash';
import uri from 'urijs';
import { setIsLoaded } from './set-is-loaded';
import { setIsLoading } from './set-is-loading';
import Wix from '../services/wix-sdk-polyfill';
import { isEditor } from '../selectors/view-mode-selectors';
import { getConfig } from '../services/config';
import { createAction, MODAL_ROOT_PATH } from '@wix/communities-blog-client-common';

import { isWixModalIframePresent } from '../services/is-iframe-present';

export const WIX_MODAL_CLOSED = 'load-and-persist-wix-modal/CLOSED';
export const wixModalClosed = createAction(WIX_MODAL_CLOSED);

const MODAL_POSITION = {
  origin: Wix.WindowOrigin.FIXED,
  placement: Wix.WindowPlacement.CENTER,
};

const loadWixModal = () => (dispatch, getState, { baseUrl }) => {
  const debug = uri(window.location.search).search(true).debug;
  const url = `${baseUrl}${MODAL_ROOT_PATH}`;

  dispatch(setIsLoading('modal', undefined, true));

  Wix.openPopup(
    `${url}?&section-url=${getConfig().sectionUrl}&debug=${debug}`,
    '100%',
    '0',
    MODAL_POSITION,
    undefined,
    Wix.Theme.BARE,
  );
};

const loadWixModalIfPossible = () => (dispatch, getState) => {
  // Double modal prevention. After login viewer revives previous iframes, so modal gets spawned automatically if it was there before
  const isWixModalPresent = isWixModalIframePresent();

  if (!isWixModalPresent && !isEditor(getState())) {
    dispatch(loadWixModal());
  }
};

const resetModalState = () => (dispatch) => {
  dispatch(wixModalClosed());
  dispatch(setIsLoaded('modal', undefined, false));
  dispatch(setIsLoading('modal', undefined, false));
};

export const loadAndPersistWixModal = () => (dispatch) => {
  dispatch(loadWixModalIfPossible());

  const resetModalStateThrottled = throttle(() => dispatch(resetModalState()), 500, { trailing: false });
  const loadWixModalIfPossibleThrottled = throttle(() => dispatch(loadWixModalIfPossible()), 500, { trailing: false });

  Wix.addEventListener(Wix.Events.PAGE_NAVIGATION_OUT, resetModalStateThrottled);
  Wix.addEventListener(Wix.Events.PAGE_NAVIGATION_IN, loadWixModalIfPossibleThrottled);

  Wix.addEventListener(Wix.Events.EDIT_MODE_CHANGE, ({ editMode }) =>
    dispatch(editMode === 'editor' ? resetModalState() : loadWixModal()),
  );
};
